import React, { useState } from 'react'
import { message, Form, Input, Button } from 'antd'
import { FormComponentProps } from 'antd/lib/form'

import styles from './index.module.less'
import { User, UserSelfUpdateFormValues } from '../../types'

interface UserFormProps extends FormComponentProps {
	user: User
	updateSelf(values: UserSelfUpdateFormValues): Promise<void>
	afterSave(): void
}

const UserForm = ({ user, afterSave, form, updateSelf }: UserFormProps) => {
	const [isSaving, setIsSaving] = useState<boolean>(false)

	const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault()
		form.validateFields(
			async (errors, values): Promise<void> => {
				if (errors) {
					return
				}

				setIsSaving(true)

				try {
					await updateSelf({ email: values.email, name: values.name, password: values.password })
					message.success('Your details have been successfully updated.')
				} catch (e) {
					message.error('There was an unexpected error when attempting to update your details. Please try again.')
				} finally {
					setIsSaving(false)
				}

				afterSave()
			}
		)
	}

	return (
		<Form hideRequiredMark layout='horizontal' labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} labelAlign='left' onSubmit={onSubmit}>
			<Form.Item label='Name'>
				{form.getFieldDecorator('name', {
					initialValue: user.name,
					rules: [
						{
							whitespace: true,
							required: true,
							message: 'Name is required'
						}
					]
				})(<Input />)}
			</Form.Item>
			<Form.Item hasFeedback label='Email'>
				{form.getFieldDecorator('email', {
					initialValue: user.email,
					rules: [
						{
							whitespace: true,
							required: true,
							message: 'Email is required'
						},
						{
							type: 'email',
							message: 'Please enter a valid email'
						}
					]
				})(<Input placeholder='Enter Email' spellCheck={false} type='text' />)}
			</Form.Item>
			<Form.Item hasFeedback label='Password' extra='Leave blank to keep password the same'>
				{form.getFieldDecorator('password', {
					initialValue: null,
					rules: [
						{
							whitespace: true,
							required: false
						},
						{
							pattern: /^(?=.*\d)(?=.*[A-Z])([^\s]){8,}$/,
							message: 'Password must be a minimum of 8 characters and contain at least one lowercase letter, one uppercase letter and one number.'
						}
					]
				})(<Input type='password' allowClear spellCheck={false} />)}
			</Form.Item>
			<div className={styles.submitButton}>
				<Button loading={isSaving} className={styles.submitButton} type='primary' htmlType='submit'>
					Save
				</Button>
			</div>
		</Form>
	)
}

export default Form.create<UserFormProps>()(UserForm)
